/* Alarie - oferta de bienvenida discreta (sin juego, sin pedir datos).
   1) A los 30 s, al bajar un tercio de la pagina o al ir a cerrar la pestana (ordenador)
      sale en medio de la pantalla una tarjeta pequena: "Un detalle para ti: 10% en tu pedido"
      con el codigo a la vista.
   2) Boton "Copiar codigo": copia el codigo y la tarjeta confirma "Codigo del 10% copiado ·
      Aplicalo en la cesta" y se va sola. Vale hasta las 23:59 de ese dia (si se copia
      a partir de las 23:00, hasta las 23:59 del dia siguiente).
   3) En la cesta, solo para quien lo copio y mientras le dure el plazo:
      "Tu codigo del 10%: ALARIE10 [Copiar]" y un campo "Codigo de descuento" con "Aplicar".
      Al caducar desaparece todo y, si lo tenia aplicado, se quita de la cesta.
   4) Cuando sale (reglas de Angel, 24 oct 2026):
      - Si NO lo ha usado: vuelve a salir en cada visita (una vez por visita).
      - Si lo ha usado (copio o aplico el codigo): no vuelve a salir hasta pasados 7 dias.
      - Nunca sale con la cesta llena, en la cesta, en el pago ni en la cuenta.
   Modo prueba (test:true en alarie-assets): sale en cada pagina, tambien en el editor.
   Configuracion en alarie-assets: window.alCartas = {code, pct, hours, test}. */
(function () {
  'use strict';
  if (window.__alCartas) return;
  window.__alCartas = true;

  var CFG = window.alCartas || {};
  var CODE = CFG.code || 'ALARIE10';
  var PCT = CFG.pct || 10;
  var DELAY = 30000;
  var AGAIN_MS = (CFG.hours || 168) * 3600000;
  var TEST = !!CFG.test;
  var KEY = 'alCartas';
  var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  if (!TEST && window.Shopify && Shopify.designMode) return;
  if (/\/(checkouts?|account)\b/.test(location.pathname)) return;

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
  var st = load();

  function cartJs() { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function setCode(code) {
    return fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ discount: code }) });
  }

  /* Copia un texto (con plan B para navegadores antiguos) */
  function copyText(t) {
    function fallback() {
      var a = document.createElement('textarea');
      a.value = t; a.setAttribute('readonly', '');
      a.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      document.body.appendChild(a); a.select();
      try { a.setSelectionRange(0, t.length); } catch (e) {}
      try { document.execCommand('copy'); } catch (e) {}
      a.remove();
    }
    try {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t).catch(fallback);
    } catch (e) {}
    fallback();
    return Promise.resolve();
  }

  /* Hasta las 23:59 de hoy; a partir de las 23:00, hasta las 23:59 de manana. */
  function endOfOffer() {
    var n = new Date();
    var e = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 23, 59, 59);
    if (n.getHours() >= 23) e.setDate(e.getDate() + 1);
    return e.getTime();
  }
  function until(ts) {
    var d = new Date(ts), now = new Date();
    var hm = (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    var day0 = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    var days = Math.floor((new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime() - day0) / 86400000);
    var dia = days <= 0 ? 'hoy' : days === 1 ? 'mañana' : 'el ' + d.getDate() + '/' + (d.getMonth() + 1);
    return dia + ' a las ' + hm;
  }
  function live() { return st.exp && st.exp > Date.now(); }

  /* ---------- estilos ---------- */
  var css = [
    /* Tarjeta premium: blanca, sombra suave, titular en la serif de la web y boton negro */
    '.alof{position:fixed;left:50%;top:50%;z-index:2147483000;width:min(360px,calc(100vw - 32px));background:#fff;border:0;border-radius:22px;box-shadow:0 24px 70px rgba(17,17,17,.22),0 2px 8px rgba(17,17,17,.06);font-family:"Jost",sans-serif;color:#111;overflow:hidden;opacity:0;transform:translate(-50%,-50%) scale(.96);transition:opacity .3s ease,transform .45s cubic-bezier(.2,.7,.2,1)}',
    '.alof.is-on{opacity:1;transform:translate(-50%,-50%)}',
    '.alof-bg{position:fixed;inset:0;z-index:2147482999;background:rgba(17,17,17,.38);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);opacity:0;transition:opacity .3s ease}',
    '.alof-bg.is-on{opacity:1}',
    '.alof__img{display:block;width:100%;height:150px;object-fit:cover;object-position:50% 53%;background:#D8CBEA}',
    '.alof__in{padding:22px 24px 20px;text-align:center}',
    '.alof__x{position:absolute;top:10px;right:10px;z-index:2;width:32px;height:32px;border:0;border-radius:99px;background:rgba(255,255,255,.85);color:#111;font-size:19px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}',
    '.alof__x:hover{background:#fff}',
    '.alof__eb{margin:0 0 6px;font-size:11px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:#8A8580}',
    '.alof__h{margin:0;font-family:"Instrument Serif",Georgia,serif;font-weight:400;letter-spacing:-.02em;font-size:40px;line-height:1;color:#111}',
    '.alof__p{margin:8px 0 16px;font-size:14.5px;line-height:1.45;color:#6E6A66}',
    '.alof__p b{color:#111;font-weight:600}',
    '.alof__code{display:flex;align-items:center;justify-content:center;gap:10px;margin:0 0 12px;padding:12px 14px;border:1px solid #E2DBFB;border-radius:99px;background:#F6F3FD;font:600 17px/1 "Jost",sans-serif;letter-spacing:.2em;color:#111;-webkit-user-select:all;user-select:all}',
    '.alof__code svg{width:16px;height:16px;color:#7A62C6;flex:0 0 auto}',
    '.alof__btn{display:block;width:100%;min-height:50px;border:0;border-radius:99px;background:#111;color:#fff;font:500 15.5px/1 "Jost",sans-serif;letter-spacing:.03em;cursor:pointer;box-shadow:none;transition:background .2s ease,transform .15s ease}',
    '.alof__btn:hover{background:#2A2A2A}',
    '.alof__btn:active{transform:scale(.98)}',
    '.alof__no{display:block;margin:10px auto 0;border:0;background:none;color:#8A8580;font:500 13px "Jost",sans-serif;cursor:pointer}',
    '.alof__no:hover{color:#111}',
    '.alof__ok{padding:30px 24px 24px;text-align:center}',
    '.alof__ic{width:46px;height:46px;margin:0 auto 12px;border-radius:99px;background:#7A62C6;color:#fff;display:flex;align-items:center;justify-content:center}',
    '.alof__ic svg{width:22px;height:22px}',
    '.alof__ok .alof__h{font-size:34px}',
    '.alof__ok .alof__code{margin:14px 0 10px}',
    '.alof__ok .alof__p{margin:0;font-size:14px}',
    '@media(max-width:749px){.alof__h{font-size:36px}.alof__img{height:130px}}',
    '@media(prefers-reduced-motion:reduce){.alof,.alof.is-on{transition:opacity .2s ease;transform:translate(-50%,-50%)}}',
    /* caja del codigo en la cesta, mismo estilo */
    '.alcz-box{margin:0 0 12px;padding:12px 14px;border-radius:14px;background:#fff;border:1px solid #E4E0DA;font:500 13.5px/1.35 "Jost",sans-serif;color:#111}',
    '.alcz-line{display:flex;align-items:center;flex-wrap:wrap;gap:6px 8px;margin:0;color:#6E6A66}',
    '.alcz-line b{font-weight:600;color:#111;letter-spacing:.14em}',
    '.alcz-copy{display:inline-flex;align-items:center;gap:5px;border:1px solid #E2DBFB;border-radius:99px;background:#F6F3FD;color:#7A62C6;font:600 12px/1 "Jost",sans-serif;padding:6px 11px;cursor:pointer}',
    '.alcz-copy svg{width:12px;height:12px}',
    '.alcz-until{flex-basis:100%;font-size:12px;color:#8A8580}',
    '.alcz-form{display:flex;gap:8px;margin-top:10px}',
    '.alcz-form input{flex:1 1 auto;min-width:0;height:44px;border:1px solid #E4E0DA;border-radius:99px;background:#fff;padding:0 16px;font:500 16px "Jost",sans-serif;color:#111;letter-spacing:.06em;text-transform:uppercase}',
    '.alcz-form input::placeholder{text-transform:none;letter-spacing:0;color:#9A958F}',
    '.alcz-form input:focus{outline:none;border-color:#7A62C6}',
    '.alcz-apply{flex:0 0 auto;height:44px;border:0;border-radius:99px;background:#111;color:#fff;font:500 14px/1 "Jost",sans-serif;letter-spacing:.02em;padding:0 20px;cursor:pointer}',
    '.alcz-apply[disabled]{opacity:.6}',
    '.alcz-msg{margin:7px 0 0 4px;font-size:12.5px;color:#B3261E}',
    '.alcz-msg:empty{display:none}',
    '.alcz-done{display:flex;align-items:center;gap:9px;margin-top:10px;padding:10px 12px;border-radius:99px;background:#F6F3FD;border:1px solid #E2DBFB;color:#111;font-weight:500}',
    '.alcz-done .alcz-ck{flex:0 0 22px;width:22px;height:22px;border-radius:99px;background:#7A62C6;color:#fff;display:flex;align-items:center;justify-content:center}',
    '.alcz-done .alcz-ck svg{width:13px;height:13px}',
    '.alcz-done span.alcz-t{flex:1}',
    '.alcz-done b{letter-spacing:.1em;font-weight:600}',
    '.alcz-rm{border:0;background:none;color:#6E6A66;font-size:18px;line-height:1;cursor:pointer;padding:0 4px}'
  ].join('');
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  var COPY = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2.5"/><path d="M5 15V6.5A1.5 1.5 0 0 1 6.5 5H15"/></svg>';
  var IMG = CFG.photo || 'https://cdn.shopify.com/s/files/1/1080/2446/3694/files/image_3751e8de-5073-4478-b615-bc4a1662962e.png?v=1791738247&width=760';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ---------- la tarjeta ---------- */
  var card = null, bg = null;
  function hide() {
    if (!card) return;
    var c = card, g = bg; card = null; bg = null;
    c.classList.remove('is-on');
    if (g) g.classList.remove('is-on');
    setTimeout(function () {
      if (c.parentNode) c.parentNode.removeChild(c);
      if (g && g.parentNode) g.parentNode.removeChild(g);
    }, 450);
  }
  function open() {
    if (card) return;
    try { sessionStorage.setItem(KEY + 'Visit', '1'); } catch (e) {}   /* ya ha salido en esta visita */
    var late = new Date().getHours() >= 23;
    card = document.createElement('div');
    card.className = 'alof';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-label', 'Un detalle para ti');
    card.innerHTML =
      '<button type="button" class="alof__x" aria-label="Cerrar">&times;</button>' +
      '<img class="alof__img" src="' + IMG + '" alt="" width="760" height="300">' +
      '<div class="alof__in">' +
      '<p class="alof__eb">Un detalle para ti</p>' +
      '<p class="alof__h">' + PCT + '% en tu pedido</p>' +
      '<p class="alof__p">También en el pack 3x2. <b>' + (late ? 'Hasta mañana a las 23:59.' : 'Solo hoy, hasta las 23:59.') + '</b></p>' +
      '<div class="alof__code">' + CODE + COPY + '</div>' +
      '<button type="button" class="alof__btn">Copiar código</button>' +
      '<button type="button" class="alof__no">Ahora no</button>' +
      '</div>';
    /* Sale en medio de la pantalla, con un velo oscuro detras; tocar fuera la cierra */
    bg = document.createElement('div');
    bg.className = 'alof-bg';
    bg.addEventListener('click', hide);
    document.body.appendChild(bg);
    document.body.appendChild(card);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      if (card) card.classList.add('is-on');
      if (bg) bg.classList.add('is-on');
    }); });
    card.querySelector('.alof__x').addEventListener('click', hide);
    card.querySelector('.alof__no').addEventListener('click', hide);
    var b = card.querySelector('.alof__btn');
    b.addEventListener('click', function () {
      copyText(CODE);
      if (!live()) { st.exp = endOfOffer(); }
      st.used = Date.now(); save(st);   /* lo ha usado: no vuelve a salir en 7 dias */
      confirmCard();
      tick();
    });
  }
  function confirmCard() {
    if (!card) return;
    card.innerHTML =
      '<button type="button" class="alof__x" aria-label="Cerrar">&times;</button>' +
      '<div class="alof__ok"><div class="alof__ic">' + CHECK + '</div>' +
      '<p class="alof__h">Código copiado</p>' +
      '<div class="alof__code">' + CODE + '</div>' +
      '<p class="alof__p">Aplícalo en la cesta. Válido hasta ' + until(st.exp) + '.</p>' +
      '</div>';
    card.querySelector('.alof__x').addEventListener('click', hide);
    setTimeout(hide, 6000);
  }

  /* ---------- caja del codigo en la cesta ---------- */
  var timer = 0, applied = false;

  /* Vuelve a pintar la cesta sin cerrarla (igual que los botones de la cesta) */
  function reloadCart(from) {
    return fetch(window.location.pathname + window.location.search, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var oldC = document.querySelector('#cart-drawer cart-drawer-component');
        var newC = doc.querySelector('#cart-drawer cart-drawer-component');
        if (oldC && newC && from && from.closest('#cart-drawer')) { oldC.replaceWith(document.importNode(newC, true)); return; }
        var oldM = document.querySelector('main'), newM = doc.querySelector('main');
        if (oldM && newM && location.pathname.indexOf('/cart') === 0) oldM.innerHTML = newM.innerHTML;
        else if (oldC && newC) oldC.replaceWith(document.importNode(newC, true));
      }).catch(function () { window.location.reload(); });
  }

  function boxHtml() {
    return '<p class="alcz-line">Tu código del ' + PCT + '%: <b>' + CODE + '</b> ' +
      '<button type="button" class="alcz-copy">' + COPY + '<span>Copiar</span></button>' +
      '<span class="alcz-until"></span></p>' +
      '<div class="alcz-slot"></div>';
  }
  function slotHtml() {
    if (applied) {
      return '<div class="alcz-done"><span class="alcz-ck">' + CHECK + '</span>' +
        '<span class="alcz-t"><b>' + CODE + '</b> aplicado -' + PCT + '%</span>' +
        '<button type="button" class="alcz-rm" aria-label="Quitar código">&times;</button></div>';
    }
    return '<div class="alcz-form"><input type="text" class="alcz-in" placeholder="Código de descuento" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="Código de descuento">' +
      '<button type="button" class="alcz-apply">Aplicar</button></div><p class="alcz-msg"></p>';
  }
  function drawBoxes() {
    var txt = 'Válido hasta ' + until(st.exp);
    Array.prototype.forEach.call(document.querySelectorAll('.al-urg'), function (u) {
      var n = u.nextElementSibling;
      if (!n || !n.classList.contains('alcz-box')) {
        n = document.createElement('div'); n.className = 'alcz-box';
        n.innerHTML = boxHtml();
        u.parentNode.insertBefore(n, u.nextSibling);
      }
      var un = n.querySelector('.alcz-until');
      if (un && un.textContent !== txt) un.textContent = txt;
      var slot = n.querySelector('.alcz-slot');
      var want = applied ? 'done' : 'form';
      if (slot && slot.getAttribute('data-k') !== want) { slot.setAttribute('data-k', want); slot.innerHTML = slotHtml(); }
    });
  }
  function clearBoxes() {
    Array.prototype.forEach.call(document.querySelectorAll('.alcz-box, .alcz-note'), function (n) { n.remove(); });
  }
  function checkCart() {
    return cartJs().then(function (c) {
      var mine = (c.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === CODE && d.applicable !== false; })[0];
      applied = !!mine;
      if (live()) drawBoxes();
    }).catch(function () {});
  }

  /* Botones de la caja (uno solo para toda la pagina, sirve aunque la cesta se repinte) */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var box = e.target.closest('.alcz-box');
    if (!box) return;
    if (e.target.closest('.alcz-copy')) {
      var c = e.target.closest('.alcz-copy');
      copyText(CODE);
      var cl = c.querySelector('span') || c;
      cl.textContent = 'Copiado';
      setTimeout(function () { cl.textContent = 'Copiar'; }, 2000);
      return;
    }
    if (e.target.closest('.alcz-apply')) {
      var btn = e.target.closest('.alcz-apply');
      var input = box.querySelector('.alcz-in');
      var msg = box.querySelector('.alcz-msg');
      var val = (input ? input.value : '').trim().toUpperCase();
      if (msg) msg.textContent = '';
      if (!val) { if (msg) msg.textContent = 'Escribe o pega tu código.'; return; }
      if (val !== CODE || !live()) { if (msg) msg.textContent = 'Este código no es válido.'; return; }
      btn.disabled = true; btn.textContent = 'Aplicando...';
      setCode(CODE).then(function () { return cartJs(); }).then(function (c) {
        var mine = (c.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === CODE && d.applicable !== false; })[0];
        if (!mine) {
          applied = false;
          btn.disabled = false; btn.textContent = 'Aplicar';
          if (msg) msg.textContent = 'No se ha podido aplicar el código.';
          return;
        }
        applied = true;
        st.used = Date.now(); save(st);
        return reloadCart(btn).then(drawBoxes);
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Aplicar';
        if (msg) msg.textContent = 'No se ha podido aplicar el código.';
      });
      return;
    }
    if (e.target.closest('.alcz-rm')) {
      var rm = e.target.closest('.alcz-rm');
      setCode('').then(function () { applied = false; return reloadCart(rm); }).then(drawBoxes).catch(function () {});
    }
  }, true);
  /* Enter en el campo = Aplicar */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || !e.target.classList || !e.target.classList.contains('alcz-in')) return;
    e.preventDefault();
    var b = e.target.closest('.alcz-box').querySelector('.alcz-apply');
    if (b) b.click();
  }, true);

  var listening = false;
  function tick() {
    clearInterval(timer);
    if (!st.exp) return;
    if (st.exp <= Date.now()) { expire(); return; }
    checkCart();
    var step = function () {
      if (st.exp - Date.now() <= 0) { expire(); return; }
      drawBoxes();
    };
    step();
    timer = setInterval(step, 1000);
    if (!listening) { listening = true; document.addEventListener('click', function () { setTimeout(checkCart, 1500); }, true); }
  }
  function expire() {
    clearInterval(timer);
    st.exp = 0; save(st);
    clearBoxes();
    /* si lo tenia puesto en la cesta, fuera de plazo se quita */
    cartJs().then(function (c) {
      var mine = (c.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === CODE; })[0];
      if (mine) setCode('').catch(function () {});
    }).catch(function () {});
    applied = false;
  }

  /* ---------- cuando sale ---------- */
  var shown = false;
  function canShow() {
    if (card || shown) return Promise.resolve(false);
    if (TEST) return Promise.resolve(true);   /* modo prueba: sale en cada pagina */
    if (live()) return Promise.resolve(false);   /* ya tiene su codigo */
    if (st.used && Date.now() - st.used < AGAIN_MS) return Promise.resolve(false);   /* lo uso hace menos de 7 dias */
    try { if (sessionStorage.getItem(KEY + 'Visit')) return Promise.resolve(false); } catch (e) {}   /* ya salio en esta visita */
    if (location.pathname.indexOf('/cart') === 0) return Promise.resolve(false);
    return cartJs().then(function (c) { return c.item_count === 0; }).catch(function () { return false; });
  }
  function tryOpen() {
    canShow().then(function (ok) {
      if (!ok || shown) return;
      shown = true;
      open();
    });
  }
  function onScroll(e) {
    if (shown) return;
    var el = e && e.target && e.target.nodeType === 1 ? e.target : document.scrollingElement || document.documentElement;
    if (el.clientHeight < window.innerHeight * 0.6 || (el.closest && el.closest('#cart-drawer'))) return;
    var max = el.scrollHeight - el.clientHeight;
    if (max > 300 && el.scrollTop / max >= 0.35) tryOpen();
  }

  function init() {
    if (/[?&]cartas=1\b/.test(location.search)) { if (st.exp) setCode('').catch(function () {}); st = {}; save(st); try { sessionStorage.removeItem(KEY + 'Visit'); } catch (e) {} }
    /* Quien ya lo copio con la version anterior cuenta como "usado" */
    if (st.exp && !st.used) { st.used = Math.min(Date.now(), st.exp); save(st); }
    if (st.exp) tick();
    setTimeout(tryOpen, TEST ? 1500 : DELAY);
    window.addEventListener('scroll', onScroll, { passive: true, capture: true });
    if (window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) tryOpen();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
